export const NEW_CUSTOM_COMPANION = 'iHR/ads/NEW_CUSTOM_COMPANION';
export const RECEIVE_STATION_TARGETTING = 'iHr/ads/RECEIVE_STATION_TARGETTING';
export const SET_TRITON_PARTNER_IDS = 'iHr/ads/SET_TRITON_PARTNER_IDS';
export const SET_TFCD_AGE_LIMIT = 'iHr/ads/SET_TFCD_AGE_LIMIT';
export const RECIEVE_TRITON_SECURE_TOKEN =
  'iHr/ads/RECIEVE_TRITON_SECURE_TOKEN';
